import { RouteConfig, SideLink } from '@/types/utility.types'
import { IconLayoutGrid } from '@tabler/icons-react'

const dashboardModuleKey = 'dashboard'

const dashboardRoute: RouteConfig = {
  index: true,
  uid: dashboardModuleKey,
  path: '/',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/dashboard')).default,
  }),
}
export const sidelink: SideLink = {
  uid: dashboardModuleKey,
  title: 'Dashboard',
  href: '/',
  order: 1,
  icon: <IconLayoutGrid size={18} />,
}
export default dashboardRoute
